import { BadgeProps } from "./types";

export type BadgeVariant = NonNullable<BadgeProps["variant"]>;

/**
 * Boje točkica iz `Badge` kao CSS vrijednosti.
 *
 * Badge ih crta Tailwind klasama, ali `Dropdown` boju prima kao inline `backgroundColor`,
 * pa klase ondje ne pomažu. Ovdje stoje na jednom mjestu da filtar i badge u tablici ne
 * odu u različite nijanse — vrijednosti prate Tailwind `*-500` iz `Badge.dotClassName`.
 */
export const BADGE_DOT_COLORS: Record<BadgeVariant, string> = {
  info: "#3b82f6",
  warning: "#eab308",
  danger: "#ef4444",
  success: "#22c55e",
  "success-dark": "#ffffff",
  secondary: "#94a3b8",
  violet: "#8b5cf6",
};
